import { useAtomValue } from "jotai";
import { useCallback } from "react";
import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import {
  AssetType,
  assetTypeAndLinkAtomFamily,
  capitalizedAssetTypeDisplayAtom,
} from "@zapier/canvas-state";

import { useOpenAsset } from "../../hooks/useOpenAsset";

type Props = {
  nodeId: string;
};

function isValidEventAssetType(
  val: any,
): val is Exclude<AssetType, undefined | "zap"> {
  return ["zap", "table", "interface", "chatbot", "agent"].includes(val);
}

export function EditAssetButton({ nodeId }: Props) {
  const { assetType, assetLink } = useAtomValue(
    assetTypeAndLinkAtomFamily(nodeId),
  );
  const getAssetDisplayName = useAtomValue(capitalizedAssetTypeDisplayAtom);

  const openAsset = useOpenAsset();

  const onPress = useCallback(() => {
    if (assetType && isValidEventAssetType(assetType)) {
      openAsset({ url: assetLink, assetType, location: "tour" });
    }
  }, [openAsset, assetLink, assetType]);

  if (!assetType || !assetLink) {
    return null;
  }

  const maybeCapitalizedAssetType =
    assetType === "zap"
      ? getAssetDisplayName(assetType)
      : getAssetDisplayName(assetType).toLowerCase();

  return (
    <Button
      variant="secondary"
      size="compact"
      iconPosition="end"
      onPress={onPress}
    >
      {`Edit ${maybeCapitalizedAssetType}`}
      <Icon name="arrowOffsite" />
    </Button>
  );
}
